import { Undefinable } from '@ps/utils';
import { ProjectManagerSummary, Survey } from '@ps/survey-utils';
import { SurveyDto } from '../../dtos/survey.dto';
import { ProjectManagerSummaryDto } from '../../dtos/project-manager.dto';

export class SurveyFeaturesMapper {
  public mapSchedulePause(dto: SurveyDto): Survey['schedulePause'] {
    if (!dto.schedule_pause) {
      return undefined;
    }

    const info = dto.schedule_pause.info?.at(0);
    return {
      enable: !!dto.schedule_pause.enable,
      days: info?.days,
      startTime: info?.start_time,
      timezone: info?.timezone,
      duration: info?.duration,
    };
  }

  public mapUniqueLinks(dto: SurveyDto): Survey['uniqueLinks'] {
    return (
      dto.unique_links && {
        enable: !!dto.unique_links.enable,
        items: dto.unique_links.items ?? [],
      }
    );
  }

  public mapBasicToken(dto: SurveyDto): Survey['basicToken'] {
    return (
      dto.basic_token && {
        enable: !!dto.basic_token.enable,
        value: dto.basic_token.value,
      }
    );
  }

  public mapScheduleLaunch(dto: SurveyDto): Survey['scheduleLaunch'] {
    return (
      dto.schedule_launch && {
        enable: !!dto.schedule_launch.enable,
        dateTimeInIso: dto.schedule_launch.info?.dateTimeInISO,
        hours: this._padTime(dto.schedule_launch.info?.hours),
        minutes: this._padTime(dto.schedule_launch.info?.minutes),
        timezone: dto.schedule_launch.info?.timezone,
      }
    );
  }

  public mapSoftLaunch(dto: SurveyDto): Survey['softLaunch'] {
    if (!dto.soft_launch) {
      return undefined;
    }

    const quantity = dto.soft_launch.quantity;
    return {
      enable: !!dto.soft_launch.enable,
      completes: quantity ? String(quantity) : undefined,
      percentile: this._mapSoftLaunchPercentile(
        quantity,
        dto.completes_required,
      ),
    };
  }

  public mapFeot(dto: SurveyDto): Survey['feot'] {
    return (
      dto.feot && {
        isCustom: dto.feot.is_custom,
        pacing: dto.feot.pacing,
        interval: dto.feot.interval,
      }
    );
  }

  public mapDqSettings(dto: SurveyDto): Survey['dqSettings'] {
    return (
      dto.dq_settings && {
        pureScoreFilterEnabled: !!dto.dq_settings.purescore_filter_enabled,
      }
    );
  }

  public mapProjectManager(
    pm: Undefinable<ProjectManagerSummaryDto>,
  ): Undefinable<ProjectManagerSummary> {
    return (
      pm && {
        id: pm.id,
        name: pm.nm,
        email: pm.eml,
      }
    );
  }

  private _mapSoftLaunchPercentile(
    quantity: Undefinable<number>,
    completesRequired: number,
  ): string | undefined {
    if (!quantity || !completesRequired) {
      return undefined;
    }
    return String(Math.round((quantity * 100) / completesRequired));
  }

  private _padTime(value: Undefinable<string>): Undefinable<string> {
    if (!value) {
      return undefined;
    }
    const numericValue = Number(value);
    return numericValue < 10 ? `0${numericValue}` : String(numericValue);
  }
}
